module.exports = __webpack_public_path__ + "static/media/clunk-notification-alert_D_major.705c06e5.wav";